<template>
  <div class="kf_home">
    <div class="kf_header">
      <div class="leftab" @click="fahui">
        <!-- <img src="../assets/back.png" alt="" /> -->
      </div>
      <div class="dialogue-service-info">
        <div class="dialogue-service-img_i">
          <img src="https://web.bookadvert.hemakouyu.com/apk/kftx/img2.webp" alt="" />
        </div>
        <div class="dialogue-service-title">
          <div class="dialogue-service-name_p">客服笑笑（工号：57336）</div>
          <div class="dialogue-service-detail_p">客服支持平台</div>
        </div>
      </div>
    </div>
    <div class="dialogue-contain">
      <div class="tip">您好，客服笑笑（工号：57336）为您服务</div>
      <div class="dialogue-service-contain_p">
        <img
          class="avarl"
          src="https://web.bookadvert.hemakouyu.com/apk/kftx/img2.webp"
        />
        <div
          class="dialogue-text dialogue-service-text"
          style="white-space: pre-wrap; background-color: #f4f4f4"
        >
          <div
            style="
              color: #000;
              display: block;
              font-size: 0.3rem;
              margin-bottom: 12rpx;
              width: 100%;
              border-bottom: 1rpx solid #d6d6d6;
              font-weight: 600;
            "
          >
            请按下列描述解决您所遇到的问题:
          </div>
          <div style="display: block; width: 100%">
            会员权益领取 <span style="color: #f00">兑换问题</span>请回复<span
              style="font-size: 36rpx"
              >“1”</span
            >;
          </div>
          <div style="display: block; width: 100%">
            如需要退费请回复<span style="font-size: 36rpx">“2”</span>。
          </div>
          <div style="display: block; width: 100%">
            如需要退款请回复<span style="font-size: 36rpx">“3”</span>。
          </div>
        </div>
      </div>
      <div
        v-for="(item, index) in answerText"
        :key="index"
        :class="item.type == 1 ? 'dialogue-customer-contain' : 'dialogue-service-contain'"
        class="dialogue-aa"
      >
        <img
          v-if="item.type == 2"
          class="avarl"
          src="https://web.bookadvert.hemakouyu.com/apk/kftx/img2.webp"
        />
        <span class="dialogue-cc" v-html="item.text"></span>
      </div>
    </div>
    <div class="dialogue-submit">
      <div style="width: 100%; display: flex; justify-content: space-between">
        <el-input
          type="textarea"
          :rows="3"
          maxlength="100"
          placeholder="请输入内容"
          v-model="dialogueInputValue"
          class="dialogue-input-text"
        >
        </el-input>
        <div class="dialogue-input-tools">
          <!-- 小工具预留位置 -->
          <el-button
            type="primary"
            id="sendmsg"
            style="font-size: 36rpx"
            @click="sendMsgFun()"
          >
            发送
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      phone: "4008400045",
      answerText: [],
      dialogueInputValue: "",
    };
  },
  methods: {
    fahui() {
      window.history.back();
    },
    sendMsgFun(e) {
      // console.log(e, "---e----");
      if (this.dialogueInputValue == "") {
        this.$message.error("请输入内容");
        return true;
      } else {
        this.answerText.push({
          type: 1,
          text: this.dialogueInputValue,
        });
        this.submitCustomerText(this.dialogueInputValue);
        this.dialogueInputValue = "";
      }
    },
    submitCustomerText(text) {
      let a = localStorage.getItem("openId");
      if (text == "1") {
        this.getServiceText(
          `会员权益领取请点击下方链接，前往福利领取中心领取：<a class="text-color-1" style="color: #f00;" href="/equity">点击前往</a></view>`
        );
      } else if (text == "2" || text == "3") {
        let data22 = {
          afterType: text-1,
          selectType:3,
          selectValue:a,
        };
        axios.post('https://thirdpay.bytxxz.com/customerAfterCare/wechat_after',data22 ,{
          headers: {
            'Content-Type': 'application/json'
          },
          transformRequest: [data => JSON.stringify(data)]
        })
        .then(res => {
          if(res.data.code == 1){
            if (text-1 == 1) {
              this.getServiceText("您的问题我们已经安排专人处理，自动续费会在72小时内解约。");
            } else {
              this.getServiceText("您的问题我们已经安排专人处理，退款会在72小时内原路返还到您的账户中(已领取权益的用户不予退费)。");
            }
          }else{
            this.getServiceText(res.data.msg);
          }
          console.log(res.data);
        })
        .catch(error => {
          this.getServiceText("服务器异常，请稍后再试");
        });
       
      } else {
        this.tsmessage()
      }
    },
    tsmessage() {
      this.getServiceText(`<div style="
                  color: #000;
				display: block;
                  font-weight: bold;
                  margin-bottom: 12rpx;
				  width: 100%;
                ">请按下列描述解决您所遇到的问题:</div><div style="display: block;width: 100%;">会员权益领取<span style="color: #f00">兑换问题</span>请回复<span
							style="font-size: 36rpx">“1”</span>;</div><div style="display: block;width: 100%;">如需要退费请回复<span
							style="font-size: 36rpx">“2”</span>。<div style="display: block;width: 100%;">如需要退款请回复<span
							style="font-size: 36rpx">“3”</span>。`);
    },
    getServiceText(data) {
      this.answerText.push({
        type: 2,
        text: data,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialogue-aa {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

::v-deep .phoneLine {
  view {
    display: inline !important;
  }
}

.dialogue-customer-contain {
  display: flex;
  justify-content: flex-end;
  margin: 0.2rem 0;

  .dialogue-cc {
    background: #d0e6fd;
    padding: 0.2rem;
    position: relative;
    line-height: 0.5rem;
    border-radius: 0.08rem;
    text-align: left;
  }

  .dialogue-cc::after {
    content: "";
    position: absolute;
    border-top: 0.2rem solid transparent;
    border-bottom: 0.2rem solid transparent;
    border-left: 0.2rem solid #d0e6fd;
    top: 50%;
    right: -0.2rem;
    width: 0;
    height: 0;
    transform: translate(0, -50%);
  }
}

.dialogue-service-contain {
  display: flex;
  justify-content: flex-start;
  margin: 0.2rem 0;

  .dialogue-cc {
    background: #f4f4f4;
    padding: 0.2rem;
    position: relative;
    max-width: 80%;
    // white-space: pre-wrap;
    border: 0.02rem solid #f4f4f4;
    border-radius: 0.08rem;
    background-color: #f4f4f4;
    box-sizing: border-box;
    color: #333;
    // white-space: pre-wrap;
    margin-left: 0.2rem;
    line-height: 0.5rem;
    text-align: left;
  }

  .dialogue-cc::after {
    content: "";
    position: absolute;
    border-top: 0.2rem solid transparent;
    border-bottom: 0.2rem solid transparent;
    border-right: 0.2rem solid #f4f4f4;
    top: 50%;
    left: -0.2rem;
    width: 0;
    height: 0;
    transform: translate(0, -50%);
  }
}

.avarl {
  width: 0.8rem !important;
  height: 0.8rem !important;
  position: relative;
  border-radius: 0.1rem;
}

.kf_home {
  // height: calc(100vh + 3.6rem);
  width: 100%;
  background-color: #fff;

  .kf_header {
    background: #5d94f3;
    z-index: 999;
    height: 1.6rem;
    padding: 0rem;
    box-sizing: border-box;
    width: 100%;
    // border-top-left-radius: 0.08rem;
    // border-top-right-radius: 0.08rem;
    position: fixed;

    .dialogue-service-info {
      position: relative;
      top: 50%;
      margin-top: -0.4rem;
      color: #fff;
      height: 0.8rem;

      .dialogue-service-img_i {
        display: inline-block;
        margin: 0 0.2rem 0 -1rem;
        width: 0.8rem;
        height: 0.8rem;
        text-align: center;
        line-height: 0.8rem;
        vertical-align: middle;
        color: #000;
        border-radius: 50%;
        background-color: #fff;

        img {
          width: 0.8rem;
          height: 0.8rem;
          border-radius: 0.1rem;
        }
      }
    }

    .dialogue-service-title {
      display: inline-block;
      vertical-align: middle;

      .dialogue-service-name_p {
        margin: 0;
      }

      .dialogue-service-detail_p {
        margin-top: 0.1rem;
        font-size: 0.24rem;
      }
    }
  }

  .leftab {
    position: absolute;
    left: 9px;
    top: 8px;
    width: 0.6rem;
    height: 0.6rem;
    z-index: 999;
    color: #333;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .dialogue-contain {
    // -moz-calc: calc(100% - 4.4rem);
    // -webkit-calc: calc(100% - 4.4rem);
    // height: calc(100% - 4.4rem);
    height: 100vh;
    overflow-y: auto;
    padding: 2.2rem 0.2rem;
    word-wrap: break-word;
    // background-color: #efefef;
    -webkit-overflow-scrolling: touch;
    position: relative;

    .tip {
      text-align: center;
      color: #666;
      margin-bottom: 0.2rem;
    }

    .dialogue-service-contain_p {
      width: 100%;
      margin-bottom: 0.2rem;
      text-align: left;
      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
      align-items: center;

      .avarl {
        width: 0.8rem !important;
        height: 0.8rem !important;
        position: relative;
        border-radius: 0.1rem;
      }

      .dialogue-text {
        margin-left: 0.4rem;
        background-color: #fff;
        border: 0.02rem solid #fff;
        color: #333;
        line-height: 0.5rem;
      }

      .dialogue-service-text {
        word-break: break-all;
        padding: 0.2rem;
        box-sizing: border-box;
        position: relative;

        img {
          width: 100%;
        }

        view {
          display: inline-block;
        }
      }

      .dialogue-service-text::after {
        content: "";
        position: absolute;
        border-top: 0.2rem solid transparent;
        border-bottom: 0.2rem solid transparent;
        border-right: 0.2rem solid #f4f4f4;
        top: 50%;
        left: -0.2rem;
        width: 0;
        height: 0;
        transform: translate(0, -50%);
      }
    }
  }
}

.dialogue-main .dialogue-service-text::before {
  border-right: 20rpx solid #fff;
}

.dialogue-main {
  .dialogue-customer-contain {
    margin-bottom: 20rpx;
    text-align: right;
    margin-top: 1.2rem;

    .dialogue-customer-texts {
      padding: 0.2rem 0rem;
      border-top: 12px solid transparent;
      border-bottom: 12px solid transparent;
      border-left: 20px solid #d0e6fd;
      position: absolute;
      top: 50%;
      right: -20rpx;
      width: 0;
      height: 0;
    }
  }

  .dialogue-service-contain {
    width: 100%;
    margin-bottom: 20rpx;
    text-align: left;
    display: flex;
    align-items: center;
    margin-top: 1.2rem;
    flex-wrap: nowrap;
  }
}

.dialogue-submit {
  /* position: relative; */
  position: fixed;
  width: 100%;
  bottom: 0;
  padding: 0.4rem;
  height: 2rem;
  color: #000;
  word-wrap: break-word;
  border-top: 2rpx solid #ddd;
  box-sizing: border-box;
  background-color: #f4f4f4;

  .dialogue-input-text {
    overflow-y: auto;
    display: inline-block;
    padding: 10rpx 20rpx;
    /* width: 295px; */
    width: 72%;
    height: 1.4rem;
    vertical-align: middle;
    white-space: pre-wrap;
    word-wrap: break-word;
    resize: none;
    border-right: 2rpx solid #ddd;
    box-sizing: border-box;
  }

  .dialogue-input-tools {
    display: inline-block;
    /* width: 80px;
    height: 80px; */
    width: 18%;
    height: 1rem;
    background-color: #f4f4f4;
    /* padding: 0 13px; */
    vertical-align: middle;
    line-height: 1rem;
    /* line-height: 80px; */
    text-align: center;
    /* border: 1px solid #ddd; */
  }
}
</style>
